import React, { useEffect } from 'react';

import PageContainer from 'Components/Atoms/PageContainer';
import WithDrawer from 'Components/Templates/WithDrawer';
import PayrollHistoryTable from 'Components/Organisms/PayrollHistoryTable';

const PayrollHistory: React.FC = () => {
  useEffect(() => {
    document.title = 'Payroll History - Orion';
  }, []);

  return (
    <WithDrawer>
      <PageContainer>
        <PayrollHistoryTable />
      </PageContainer>
    </WithDrawer>
  );
};

export default PayrollHistory;
